module.exports = __webpack_public_path__ + "img/document1.afc0d73b.png";